// extracted by mini-css-extract-plugin
export default {"tagging__service":"TaggingSettings_tagging__service__kZdt+","tagging__service__label":"TaggingSettings_tagging__service__label__h9bvd"};